// src/features/uninsured/uninsuredItemSlice.ts

import { createSlice } from "@reduxjs/toolkit"
import { UninsuredCategorySerializer } from "@/types/uninsured"
import { fetchUninsuredCategory } from "@core/api/uninsuredApi"

interface UninsuredCategoryState {
  uninsuredCategories: UninsuredCategorySerializer[]
  loading: boolean
  error: string | null
}

const initialState: UninsuredCategoryState = {
  uninsuredCategories: [],
  loading: false,
  error: null,
}

const uninsuredCategorySlice = createSlice({
  name: "uninsuredCategory",
  initialState,
  reducers: {
    // 모든 아이템을 초기화할 때
    clearUninsuredCategory(state) {
      state.uninsuredCategories = []
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchUninsuredCategory.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUninsuredCategory.fulfilled, (state, action) => {
        state.loading = false
        state.uninsuredCategories = action.payload || []
        state.error = null
      })
      .addCase(fetchUninsuredCategory.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "알 수 없는 오류 발생"
      })
  },
})

export const { clearUninsuredCategory } = uninsuredCategorySlice.actions

export default uninsuredCategorySlice.reducer
